module.exports = __webpack_public_path__ + "media/images/brand/footer-slogan3-d53c5c98f7403a7bae0b1d33ab3a6551.svg";